import React, { Component } from "react";
import PageWrapper from "../../components/PageWrapper/PageWrapper";
import { Helmet } from "react-helmet";
import { withPrismic } from "../../components/Prismic/Prismic";
import './Homepage.css';
import _ from "lodash";
import Slider from "react-slick";
import videowall from "../../assets/img/videowall.jpg";
import aside from "../../assets/img/aside.jpg";
import RichText from "../../components/RichText/RichText";
import {Link as PrismicLink} from 'prismic-reactjs';
import {DefaultMetaTags, PrismicConfig} from "../../config";
import Loading from "../../components/Loading/Loading";

class Homepage extends Component {
	
	componentDidUpdate(oldProps) {
		if(!this.props.prismic || this.props.homepage || oldProps === this.props) return null;
		this.props.prismic.getHomepage(this.props.lang);
	}
	
	renderSlides() {
		let slides = this.props.homepage.data.slide,
		output = [],
		index = 0;
		if(!slides || !slides.length) return null;
		_.each(slides, (slide) => {
			
			const background = slide.background ? `url(${slide.background.url})` : '';
			const copy = slide.copy ? <RichText content={slide.copy} /> : '';
			const to = slide.button_link ? PrismicLink.url(slide.button_link, PrismicConfig.linkResolver) : '/';
			const link = (<a
				href={to ? to : '/'}
				target={slide.button_link && slide.button_link.target ? slide.button_link.target : '_self'}
				className="button -secondary">{slide.button_text}
			</a>);

			output.push(<div key={index}>
			<div className="banner" style={{backgroundImage: background}} >
				<div className="content-frame">
					<div className="content-holder">
						<div className="content">
							{copy}
							{link}
						</div>
					</div>
				</div>
			</div>
			</div>);
			index++;
			
		});
		return output;
	}
	
	render() {
		
		if(!this.props.homepage || !this.props.homepage.data) return <Loading />;
		
		const sliderSettings= {
			dots: false,
			infinite: true,
			speed: 800,
			slidesToShow: 1,
			slidesToScroll: 1,
			autoplaySpeed: 5000,
			autoplay:true
		};
		
		return (
			<PageWrapper context="home" full={true}>
			<Helmet title={`Videos for Change | Home`} />
			<DefaultMetaTags title={`Videos for Change | Home`} />
			<section className="home-banner" >
			<div className="container">
			<Slider {...sliderSettings}>
			{this.renderSlides()}
			</Slider>
			{/* <div className="banner" style={{backgroundImage : `url(${banner})`}} > */}
			{/* <div className="content"> */}
			{/* <RichText content={this.props.homepage.data.introduction} slices={this.props.homepage.data.introduction_slices} /> */}
			{/* </div> */}
			{/* </div> */}
			</div>
			</section>
			<section className="home-about" >
			<div className="container">
			<div className="content">
			<RichText content={this.props.homepage.data.about} slices={this.props.homepage.data.about_slices} />
			</div>
			</div>
			</section>
			<section className="home-videos" style={{backgroundImage : `url(${videowall})`}}>
			<div className="container">
			<div className="content">
			<RichText content={this.props.homepage.data.videos} slices={this.props.homepage.data.videos_slices} />
			</div>
			</div>
			</section>
			<section className="home-aside">
			<div className="image-background" style={{backgroundImage : `url(${aside})`}}>
			<div className="container">
			<div className="content">
			<RichText content={this.props.homepage.data.pull_out} slices={this.props.homepage.data.pull_out_slices}/>
			</div>
			</div>
			</div>
			</section>
			</PageWrapper>
		);
	}
}

export default withPrismic(Homepage);



// WEBPACK FOOTER //
// ./src/pages/Homepage/Homepage.js